<template>
    <div id="home-header-navigation" class="homeHeaderNavigation">
        <!-- web -->
        <div
            :key="6"
            :id="`nav_${viewList[0].name}`"
            class="navItem"
            :class="{
                activeNavItem: currentMode.name == viewList[0].name,
            }"
            @click="changeMode(viewList[0])"
        >
            <img
                :id="`nav-icon_${viewList[0].name}`"
                class="navIcon"
                :src="viewList[0].icon"
            />
            <div :id="`nav-title_${viewList[0].name}`" class="navTitle">
                {{ viewList[0].name }}
            </div>
        </div>
        <!-- end of web -->

        <div
            :class="{
                activeNavItem: currentMode.name == 'images',
                navItem: true,
            }"
            @click="
                changeModeExternal(
                    'images',
                    `https://images.search.yahoo.com/yhs/search?p={{QUERY}}&type=${typeTag}`
                )
            "
        >
            <a id="nav-link_images" class="navLink"></a>
            <img
                id="nav-link_Images"
                src="/assets/images/common/icon_images.svg"
            />
            <div class="navTitle">
                Images
            </div>
        </div>

        <div
            :class="{
                activeNavItem: currentMode.name == 'video',
                navItem: true,
            }"
            @click="
                changeModeExternal(
                    'video',
                    `https://video.search.yahoo.com/yhs/search?p={{QUERY}}&type=${typeTag}`
                )
            "
        >
            <a id="nav-link_video" class="navLink"></a>
            <img
                id="nav-link_Video"
                class="navLink"
                src="/assets/images/common/icon_video.svg"
            />
            <div class="navTitle">
                Video
            </div>
        </div>
        <div
            :class="{
                activeNavItem: currentMode.name == 'news',
                navItem: true,
            }"
            @click="
                changeModeExternal(
                    'news',
                    `https://news.search.yahoo.com/search?p={{QUERY}}&type=${typeTag}`
                )
            "
        >
            <a id="nav-link_news" class="navLink"></a>
            <img
                id="nav-link_News"
                class="navLink"
                src="/assets/images/common/icon_news.svg"
            />
            <div class="navTitle">
                News
            </div>
        </div>

        <div
            :class="{
                activeNavItem: currentMode.name == 'shopping',
                navItem: true,
            }"
            @click="
                changeModeExternal(
                    'shopping',
                    `https://shopping.yahoo.com/search?p={{QUERY}}&type=${typeTag}`
                )
            "
        >
            <a id="nav-link_shopping" class="navLink"></a>
            <img
                id="nav-link_Shopping"
                class="navLink"
                src="/assets/images/common/icon_shopping.svg"
            />
            <div class="navTitle">
                Shopping
            </div>
        </div>
        <div
            v-for="(navItem, index) in reorderedViewList"
            :key="index"
            :id="`nav_${navItem.name}`"
            :class="{
                activeNavItem: currentMode.name == navItem.name,
                navItem: true,
                yah: true,
            }"
            @click="changeMode(navItem)"
        >
            <img
                :id="`nav-icon_${navItem.name}`"
                class="navIcon"
                :src="navItem.icon"
            />
            <div :id="`nav-title_${navItem.name}`" class="navTitle">
                {{ navItem.name }}
            </div>
        </div>
        <div id="yahoo-links-more" class="navItem more dropdown">
            <a id="nav-link_more" class="navLink dropbtn" href="#">
                <img
                    id="nav-link_More"
                    class="navLink"
                    src="/assets/images/common/icon_more.svg"
                />
                More</a
            >
            <div class="dropdown-content">
                <div
                    v-for="(navItem, index) in reorderedViewList"
                    :key="index + 6"
                    :id="`nav_${navItem.name}`"
                    :class="{
                        activeNavItem: currentMode.name == navItem.name,
                    }"
                >
                    <a
                        v-if="currentMode"
                        :href="`${navItem.path.substring(1)}${querySearch}`"
                        @click="changeMode(navItem)"
                    >
                        <img
                            :id="`nav-icon_${navItem.name}`"
                            class="moreLink"
                            :src="navItem.icon"
                        />{{ navItem.name }}</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from "query-string";
import {
    reorderedVerticalList,
    verticalList,
    defaultVertical,
} from "@/linkLists";
import { YAHOO_COBRAND_URL } from "@/urls";
import FreshyFooter from "@/components/footer/Footer.vue";
import AutoCompleteInput from "@/components/autoCompleteInput/AutoCompleteInput.vue";
import { pageviewEvent, searchEvent, clickEvent, trackGA } from "@/analytics";
import { getBranding } from "@/branding";
import { documentReady, setSearchHistory } from "@/common";
import home from "../common/mixins/home";

export default {
    name: "reordered-web-home",
    data() {
        const qs = queryString.parse(window.location.search);
        return {
            searchParams: qs || null,
            query: qs.q || null,
            typeTag: qs.type || null,
            viewList: verticalList,
            reorderedViewList: reorderedVerticalList,
            branding: getBranding(),
            currentMode: defaultVertical,
        };
    },
    computed: {
        querySearch() {
            return window.location.search;
        },
    },
    methods: {
        changeMode(mode) {
            this.currentMode = mode;
            this.$emit("changeMode", mode);
        },
        changeModeExternal(label, path) {
            this.currentMode = { external: true, name: label, path };
            this.$emit("changeModeExternal", label, path);
        },
    },
};
</script>

<style scoped src="./home.css"></style>
